import Link, { LinkProps } from "@mui/material/Link";
import { MarketplaceResultType } from "config";
import React from "react";

export function getMarketplaceProfilePath(profileType: MarketplaceResultType, profileId: string): string {
  return `/marketplace/${profileType.toLowerCase()}/${profileId}`;
}

type MarketplaceProfileLinkProps = Omit<LinkProps, "href" | "onClick"> & {
  profileType: MarketplaceResultType;
  profileId: string;
  onOpen: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

/**
 * A real link to a marketplace profile, so a result can be reached with the keyboard and opened in a
 * new tab. A plain click still goes through `onOpen`, which is what lets the vendor-team picker open
 * the profile in a dialog instead of navigating away from the team being built.
 */
export default function MarketplaceProfileLink(props: Readonly<MarketplaceProfileLinkProps>) {
  const { profileType, profileId, onOpen, ...linkProps } = props;

  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    // A modified click is the reader asking for a new tab or window: leave that to the browser.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    onOpen(event);
  }

  return <Link {...linkProps} href={getMarketplaceProfilePath(profileType, profileId)} onClick={handleClick} />;
}
